import { Component, OnDestroy, signal } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, RouterModule, RouterOutlet } from '@angular/router';
import { CoreModule } from './core/core.module';
import { HeaderComponent } from "./shared/header/header.component";
import { FormsModule } from '@angular/forms';
import { CommunicateService } from './core/services/communicate.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { TranslateService } from '@ngx-translate/core';
import { CommonModule, DatePipe, TitleCasePipe } from '@angular/common';
import { SwUpdate } from '@angular/service-worker';
import { ApmModule, ApmService } from '@elastic/apm-rum-angular'
import { DocumentSidebarComponent } from './shared/document-sidebar/document-sidebar.component';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { CommonApiService } from './core/services/common-api.service';
import { AdminNotifyService } from './core/services/admin-notify.service';
import { ToastrService } from 'ngx-toastr';
import { v4 as uuidv4 } from 'uuid';
import { isHubSpotUrl } from './hubspot/utils/packet-id.util';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  imports: [RouterOutlet, RouterModule, FormsModule, HeaderComponent, DocumentSidebarComponent, CoreModule, CommonModule, TranslateModule], providers: [DatePipe, TitleCasePipe]
})
export class AppComponent implements OnDestroy {
  title = 'sign-paperless';
  userId = signal<any>('');
  isLoggedIn: boolean = false;
  showUpdatePopup = signal(false);
  refreshCountdown = signal(5);
  hideHeader: boolean = true;
  hideSidebar: boolean = false;
  isSearchModalOpen: boolean = false;
  preUrl: any;
  isShortcutsOpen = false;
  istalWindCssHide = false;
  hideHeaderUrls = ['/add-question', '/edit-question',
    '/edit-dynamic-functions', '/add-dynamic-functions',
    '/add-rule', '/edit-rule', '/add-document', '/edit-document', 'add-messaging-template', 'edit-messaging-template',
    '/add-participant', '/edit-participant', '/add-template', '/edit-template', '/add-employee', '/edit-employee',
    '/send-packet', '/data-entry', 'landing', 'forms/basic', 'document-self-sign', 'document-self-sign', '/hubspot', 'create-document']
  showLeavePageWarning = ['/add-question', '/edit-question',
    '/edit-dynamic-functions', '/add-dynamic-functions',
    '/add-rule', '/edit-rule', '/add-document', '/edit-document', 'add-messaging-template', 'edit-messaging-template',
    '/add-participant', '/edit-participant', '/add-template', '/edit-template', '/add-employee', '/edit-employee',
    '/send-packet', '/data-entry', 'landing', 'forms/basic']


  hideTelwindCss = ['/edit-document', '/add-messaging-template', '/edit-messaging-template',
    '/forms/basic', '/document-self-sign', '/hubspot']
  hideSidebarUrls = ['create-document']
  isDarkMode = false;
  private updatePromptShown = false;
  private isRefreshing = false;
  private countdownTimer: ReturnType<typeof setInterval> | null = null;
  private autoRefreshTimer: ReturnType<typeof setTimeout> | null = null;
  private updateCheckTimer: ReturnType<typeof setInterval> | null = null;
  private readonly AUTO_REFRESH_SECONDS = 5;
  private readonly UPDATE_CHECK_INTERVAL_MS = 60_000;

  constructor(private router: Router, public communicate: CommunicateService,
    private loader: NgxUiLoaderService, private translateService: TranslateService,
    private readonly swUpdate: SwUpdate,
    private apmService: ApmService,
    private api: CommonApiService,
    private toastr: ToastrService,
    private adminNotify: AdminNotifyService

  ) {
    this.router.events.subscribe(
      (event: any) => {
        if (event instanceof NavigationEnd) {
          let url = this.preUrl = this.router.url;
          localStorage.setItem('preUrl', url)
          this.hideHeader = this.hideHeaderUrls.some(u => url.includes(u)) || isHubSpotUrl(url)
          this.hideSidebar = this.hideHeader || this.hideSidebarUrls.some(u => url.includes(u))
          this.istalWindCssHide = this.hideTelwindCss.some(u => url.includes(u)) || isHubSpotUrl(url)
          this.isLoggedIn = url.includes('login') || url.includes('signup') || url.includes('forgot-password') || url.includes('404') || url.includes('data-entry') || url.includes('send-document-participants') || isHubSpotUrl(url)
          this.adminNotify.inspectCurrentPage(url)
        }
        if (event instanceof NavigationStart) {
          if (event.navigationTrigger === 'popstate') {
            let isExit = this.showLeavePageWarning.some(u => this.preUrl.includes(u));
            if (isExit) {
              let isAllow = confirm('Do you really want to leave this page ?');
              if (!isAllow) {
                let url = this.router.url;
                this.router.navigate([url]);
              }

            }

          }
        }
      }
    );
    this.listenForAppUpdates();
    this.setLanguage()

  }
  ngOnInit() {
    this.getTabId(); // call once on app load
    this.userId.set(Number(localStorage.getItem('userId')));

    this.communicate.isLoaderLoad.subscribe((res: any) => {
      if (res === true) {
        this.loader.start();
      } else {
        this.loader.stop();
      }
    });

    window.addEventListener('storage', (event) => {
      if (event.key === 'GLOBAL_LOGIN' && event.newValue) {
        const senderTabId = this.getTabId();
        // another tab logged in
        const data = JSON.parse(event.newValue);

        if (data.senderTabId === senderTabId) return;
        console.log('Another tab logged in, logging out this tab.', data.senderTabId, senderTabId);
        // if (localStorage.getItem('Shared_Data')) return; // if already logged in, do not logout
        // localStorage.clear(); // or remove only auth keys
        // sessionStorage.clear();
        this.goToDashboard('home');
      }
    });

    window.addEventListener('storage', (event) => {
      if (event.key === 'GLOBAL_LOGOUT' && event.newValue) {
        const senderTabId = this.getTabId();
        // another tab logged in
        const data = JSON.parse(event.newValue);
        if (data.senderTabId === senderTabId) return;
        console.log('Another tab logged out, logging out this tab.', data.senderTabId, senderTabId);
        // localStorage.clear(); // or remove only auth keys
        // sessionStorage.clear();
        this.goToDashboard('home');
      }
    });

    this.communicate.isShortcutsOpen.subscribe((isOpen: boolean) => {
      this.isShortcutsOpen = isOpen;
    });
  }

  ngOnDestroy() {
    this.clearUpdateTimers();
    if (this.updateCheckTimer) {
      clearInterval(this.updateCheckTimer);
      this.updateCheckTimer = null;
    }
  }

  private listenForAppUpdates() {
    if (!this.swUpdate?.isEnabled) {
      return;
    }

    this.swUpdate.versionUpdates.subscribe((event) => {
      if (event.type === 'VERSION_READY') {
        this.showNewBuildPopup();
      }
    });

    this.swUpdate.checkForUpdate().catch(() => { });
    this.updateCheckTimer = setInterval(() => {
      this.swUpdate.checkForUpdate().catch(() => { });
    }, this.UPDATE_CHECK_INTERVAL_MS);
  }

  private showNewBuildPopup() {
    if (this.updatePromptShown) {
      return;
    }
    this.updatePromptShown = true;
    this.showUpdatePopup.set(true);
    this.refreshCountdown.set(this.AUTO_REFRESH_SECONDS);
    document.body.style.overflow = 'hidden';

    this.countdownTimer = setInterval(() => {
      const next = this.refreshCountdown() - 1;
      this.refreshCountdown.set(Math.max(next, 0));
      if (next <= 0 && this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    }, 1000);

    this.autoRefreshTimer = setTimeout(() => {
      this.hardRefresh();
    }, this.AUTO_REFRESH_SECONDS * 1000);
  }

  hardRefresh() {
    if (this.isRefreshing) {
      return;
    }
    this.isRefreshing = true;
    this.clearUpdateTimers();

    const reload = () => window.location.reload();
    if (this.swUpdate?.isEnabled) {
      this.swUpdate.activateUpdate().then(reload).catch(reload);
    } else {
      reload();
    }
  }

  private clearUpdateTimers() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
    if (this.autoRefreshTimer) {
      clearTimeout(this.autoRefreshTimer);
      this.autoRefreshTimer = null;
    }
  }

  setLanguage() {
    let lang = navigator.language || 'en-US';
    lang = lang.split('-')[0] == 'en' ? (lang == 'en' ? 'en-US' : lang) : lang.split('-')[0];
    this.translateService.setDefaultLang('en-US');
    this.translateService.use(lang);
  }

  closeSearchModal() {
    this.isSearchModalOpen = false;
    const modal = document.getElementById('search-modal');
    if (modal) {
      modal.classList.add('hidden');
    }
  }

  closeKeyboardShortcuts() {
    this.communicate.closeShortcutsModal();
    document.body.style.overflow = '';
  }

  goToDashboard(keyLink: string) {
    this.api.allPostMethod('AccountSwitchAToB/GetToken', { userId: this.userId() }, true).subscribe({
      next: (res: any) => {
        if (!res['error'] && res['data'] && res['data']['abToken']) {
          let adminUrl: string = environment.blazzerUrl;
          let url = `${adminUrl}/verify-token?ABToken=${encodeURIComponent(res['data']['abToken'])}&ReturnUrl=${encodeURIComponent(`/${keyLink}`)}`;
          window.location.href = url;
        } else {
          this.toastr.error(res.message || 'Something went wrong!!');
        }
      },
      error: (error) => {
        this.toastr.error(error.message || 'Something went wrong!!');
      }
    });
  }

  toggleDarkMode(event: any) {
    this.isDarkMode = event;

    if (this.isDarkMode) {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
  }

  getTabId(): string {
    // if user is not logged in, generate a new tab ID for tracking
    const isLoggedIn = !!localStorage.getItem('sp-token');

    if (!isLoggedIn) {
      let tabId = uuidv4();
      sessionStorage.setItem('TAB_ID', tabId);
      return tabId;
    }

    // Agar logged in hai, toh existing ID use karo
    let tabId = sessionStorage.getItem('TAB_ID');
    if (!tabId) {
      tabId = uuidv4();
      sessionStorage.setItem('TAB_ID', tabId);
    }
    return tabId;
  }

}